import * as React from 'react';
import { SVGProps } from 'react';

const IconFrequencySizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.864 4.078a3.667 3.667 0 0 1 4.598-2.943l.805.224a1.001 1.001 0 0 1-.534 1.929l-.806-.224a1.667 1.667 0 0 0-2.09 1.339l-1.235 7.518c-.412 2.506-3.178 3.849-5.397 2.615l-.69-.384a1.002 1.002 0 0 1 .97-1.75l.691.384a1.666 1.666 0 0 0 2.453-1.19l1.235-7.518Z"
      fill="var(--color-typo-normal)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8Z"
      fill="var(--color-typo-primary)"
    />
  </svg>
);
export default IconFrequencySizeS;
